export default __webpack_public_path__ + "static/media/SportELS_LateralIzq.9325543d.webp";